
export default class Popup {
  constructor() {
    this.$element = document.querySelector('[data-sunsun-popup]');
    this.$close = this.$element.querySelectorAll('[data-sunsun-popup-close]');

    this.init();
  }

  init() {
    this.setupStyle();
    this.bindEvents();
    setTimeout(() => {
      gsap.to(this.$element, { autoAlpha: 1 })
    }, 1000);
  }

  setupStyle() {
    gsap.set(this.$element, { autoAlpha: 0 })
  }

  bindEvents() {
    this.$close.forEach($btn => {
      $btn.addEventListener("click", this.close.bind(this));
    })
  }

  close() {
    gsap.to(this.$element, { autoAlpha: 0 })
  }
}
